import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Button from 'components/CncUI/Button';
import { getOfferUrl } from 'constants/config/startPlus';

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    width: '100%',
    padding: '16px 24px',
    marginLeft: -48,
  },
  push: {
    height: 80,
  },
}));

const TrayBar = ({ offerId, from }) => {
  const classes = useStyles();
  const isEtc = (from || '').toLowerCase() === 'etc';
  return (
    <>
      <div className={classes.push} />
      <ContentBox dense className={classes.root}>
        <Grid container spacing={3} justify="flex-end" alignItems="center">
          <Grid item>
            <Typography variant="h4" noMargin>
              Back to your offer?
            </Typography>
          </Grid>
          <Grid item>
            <Grid container spacing={2} justify="flex-end" alignItems="center">
              <Grid item>
                <Typography variant="body2" size="short" noMargin>
                  Return to {isEtc ? 'ETC' : 'Start+'} to continue accepting or
                  rejecting your offer
                </Typography>
              </Grid>
              <Grid item>
                <Button href={getOfferUrl(offerId)}>Go back to offer</Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ContentBox>
    </>
  );
};

export default TrayBar;
